"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SocMapping = exports.Socs = exports.ChannelDeviceTypes = void 0;
var ChannelDeviceTypes;
(function (ChannelDeviceTypes) {
    ChannelDeviceTypes["BAILEY"] = "bailey";
    ChannelDeviceTypes["DUKE_SINGLE"] = "duke_single";
    ChannelDeviceTypes["DUKE_MASTER"] = "duke_master";
    ChannelDeviceTypes["ANDRE"] = "andre";
    ChannelDeviceTypes["SNOWFLAKE"] = "snowflake";
    ChannelDeviceTypes["CONNECT"] = "connect";
    ChannelDeviceTypes["CONNECT_DEPOP"] = "connect_depop";
})(ChannelDeviceTypes = exports.ChannelDeviceTypes || (exports.ChannelDeviceTypes = {}));
var Socs;
(function (Socs) {
    Socs["SOC_ESP32_WROOM"] = "esp32-wroom";
    Socs["SOC_ESP32_WROVER"] = "esp32-wrover";
})(Socs = exports.Socs || (exports.Socs = {}));
exports.SocMapping = {};
exports.SocMapping[Socs.SOC_ESP32_WROVER] = [
    ChannelDeviceTypes.ANDRE,
    ChannelDeviceTypes.BAILEY,
    ChannelDeviceTypes.CONNECT,
    ChannelDeviceTypes.CONNECT_DEPOP,
    ChannelDeviceTypes.DUKE_MASTER,
    ChannelDeviceTypes.DUKE_SINGLE
];
exports.SocMapping[Socs.SOC_ESP32_WROOM] = [
    ChannelDeviceTypes.SNOWFLAKE,
];
//# sourceMappingURL=ChannelsTypes.js.map